import { CommonModule } from "@angular/common";
import { Component, computed, effect, inject, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormControl, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { RouterModule } from "@angular/router";
import { HeaderService, BootstrapIcon } from "src/app/services/header.service";
import { UserService } from "src/app/services/user.service";
import { StorageService } from "src/app/shared/data-access/storage.service";

@Component({
  selector: "app-admin-dashboard",
  templateUrl: "./admin-dashboard.component.html",
  styleUrls: ["./admin-dashboard.component.scss"],
  standalone: true,
  imports: [CommonModule, MatButtonModule, ReactiveFormsModule, RouterModule],
})
export class AdminDashboardComponent {
  storageService = inject(StorageService);
  headerService = inject(HeaderService);
  userService = inject(UserService);
  BootstrapIcon = BootstrapIcon;
  timeoutControl: FormControl;
  timeoutSignal = signal<number>(0);
  private isLoading = signal<boolean>(true);

  formattedTimeout = computed(() => {
    if (this.isLoading() || this.userService.sessionTimeout() === null) {
      return "";
    }
    return this.secondsToHHmm(this.userService.sessionTimeout()!);
  });

  constructor() {
    this.headerService.setBackgroundColor("#ffffff");
    this.headerService.setHeaderTitle("Dashboard");
    this.headerService.setHeaderSubTitle("Gesamtübersicht");
    this.headerService.setHeaderIcon(BootstrapIcon.dashboard);
    this.headerService.setIsHeaderClickable(false);

    this.timeoutControl = new FormControl(
      {
        value: "",
        disabled: true,
      },
      Validators.min(1)
      // TODO - why is min(1) false under 60???
    );
    effect(() => {
      if (this.formattedTimeout()) {
        this.timeoutControl.setValue(this.formattedTimeout(), {
          emitEvent: false,
        });
      }
    });
    this.userService.sessionTimeout$
      .pipe(takeUntilDestroyed())
      .subscribe((timeout) => {
        if (timeout !== null) {
          this.isLoading.set(false);
        }
      });
  }

  ngOnInit() {
    this.timeoutControl.valueChanges.subscribe((value) => {
      if (value) {
        this.timeoutSignal.set(this.toSeconds(value));
      }
    });
  }

  toggleLogoutInput() {
    this.timeoutControl.enabled
      ? this.timeoutControl.disable()
      : this.timeoutControl.enable();
  }

  updateSessionTimeout() {
    if (!this.timeoutControl.invalid && this.timeoutSignal() > 0) {
      this.userService.editTimeout$.next(this.timeoutSignal());
      this.timeoutControl.disable();
    } else {
      alert("Ungültige Eingabe, die Mindestdauer beträgt 01:00");
    }
  }

  cancel() {
    this.timeoutControl.disable();
    this.timeoutControl.patchValue(
      this.secondsToHHmm(this.userService.sessionTimeout()!)
    );
  }

  toSeconds(time: string) {
    const hours = time.split(":")[0];
    const minutes = time.split(":")[1];
    return parseInt(hours) * 60 * 60 + parseInt(minutes) * 60;
  }

  secondsToHHmm(seconds: number): string {
    const hours = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, "0");
    const minutes = (Math.floor(seconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
    return `${hours}:${minutes}`;
  }
}
